import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import FinishRegistration from "./pages/FinishRegistration";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Debug from "./pages/Debug";
import LobbyNew from "./pages/LobbyNew";
import Lobby from "./pages/Lobby";
import LobbyGame from "./pages/LobbyGame";
import LobbyResults from "./pages/LobbyResults";
import JoinLobby from "./pages/JoinLobby";
import Admin from "./pages/Admin";
import Leaderboards from "./pages/Leaderboards";
import PublicProfile from "./pages/PublicProfile";
import Friends from "./pages/Friends";
import Ranked from "./pages/Ranked";
import SoloMap from "./pages/SoloMap";
import SoloLevel from "./pages/SoloLevel";
import Store from "./pages/Store";
import StoreSuccess from "./pages/StoreSuccess";
import StoreCancel from "./pages/StoreCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" richColors />
          <ErrorBoundary>
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/finish-registration"
              element={
                <ProtectedRoute>
                  <FinishRegistration />
                </ProtectedRoute>
              }
            />
            <Route path="/join/:code" element={<JoinLobby />} />
            <Route
              path="/solo"
              element={
                <ProtectedRoute>
                  <SoloMap />
                </ProtectedRoute>
              }
            />
            <Route
              path="/solo/level/:n"
              element={
                <ProtectedRoute>
                  <SoloLevel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lobby/new"
              element={
                <ProtectedRoute>
                  <LobbyNew />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lobby/:code"
              element={
                <ProtectedRoute>
                  <Lobby />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lobby/:code/game"
              element={
                <ProtectedRoute>
                  <LobbyGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lobby/:code/results"
              element={
                <ProtectedRoute>
                  <LobbyResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debug"
              element={
                <ProtectedRoute requireAdmin>
                  <Debug />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leaderboards"
              element={
                <ProtectedRoute>
                  <Leaderboards />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <ProtectedRoute>
                  <PublicProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/friends"
              element={
                <ProtectedRoute>
                  <Friends />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ranked"
              element={
                <ProtectedRoute>
                  <Ranked />
                </ProtectedRoute>
              }
            />
            <Route path="/ranks" element={<Navigate to="/ranked" replace />} />
            <Route
              path="/store"
              element={
                <ProtectedRoute>
                  <Store />
                </ProtectedRoute>
              }
            />
            <Route
              path="/store/success"
              element={
                <ProtectedRoute>
                  <StoreSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/store/cancel"
              element={
                <ProtectedRoute>
                  <StoreCancel />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
